import type { JpAddressValue } from '../components/JpAddressInput';

export function emptyMemberAddress(): JpAddressValue {
  return { postalCode: '', pref: '', city: '', town: '', line2: '' };
}

export function isMemberAddressComplete(a: JpAddressValue): boolean {
  return (
    a.postalCode.trim().length > 0 &&
    a.pref.trim().length > 0 &&
    a.city.trim().length > 0 &&
    a.town.trim().length > 0
  );
}

/** Stored in emp_family.if_not_address (multiline, same style as general profile). */
export function formatIfNotAddress(a: JpAddressValue): string {
  const lines: string[] = [];
  const zip = a.postalCode.trim();
  if (zip) lines.push(`〒${zip}`);
  const main = [a.pref.trim(), a.city.trim(), a.town.trim()].filter(Boolean).join('');
  if (main) lines.push(main);
  if (a.line2.trim()) lines.push(a.line2.trim());
  return lines.join('\n');
}

/** Best-effort parse when loading from DB. */
export function parseIfNotAddress(raw: string): JpAddressValue {
  const text = raw.trim();
  if (!text) return emptyMemberAddress();

  const lines = text.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  if (lines.length === 0) return emptyMemberAddress();

  let postalCode = '';
  let startIdx = 0;
  const zipMatch = lines[0].match(/^〒?\s*([\d０-９\-－]+)\s*$/);
  if (zipMatch) {
    postalCode = zipMatch[1].replace(/[０-９]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0));
    startIdx = 1;
  }

  const rest = lines.slice(startIdx);
  if (rest.length === 0) {
    return { postalCode, pref: '', city: '', town: text, line2: '' };
  }
  if (rest.length === 1) {
    return { postalCode, pref: '', city: '', town: rest[0], line2: '' };
  }

  return {
    postalCode,
    pref: '',
    city: '',
    town: rest[0],
    line2: rest.slice(1).join(' '),
  };
}

export function formatIfNotAddressDisplay(raw: string): string {
  return raw.trim() || '—';
}
